import * as core from '../../../../../../../core'

import { query } from './anticipated-response-of-change-by-workstream.query'

export const RESOURCE = {
  payload: {
    alias: 'anticipated.response.of.change.by.workstream',
    description: 'Chart view of anticipated response of change by workstream',
    name: 'Anticipated Response of Change by Workstream',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
